import { Injectable } from '@angular/core';
import { Location } from '@angular/common';
import { Subject, BehaviorSubject } from 'rxjs';
import moment from 'moment';
import { AuthenticationService, Logger } from '@app/core';
import { GlobalFilterConfigService } from './global-filters-config.service';
import { ActivatedRoute, NavigationEnd, ResolveStart, Router, RouterStateSnapshot } from '@angular/router';
import { EmailEditsComponent } from 'projects/cvreporting/src/app/features/cvreporting/main-dashboard/email-edits/email-edits.component';
import { TranslateService } from '@ngx-translate/core';
import { StaticIntialState, StaticPageConfig, StaticReturnFilter } from './global-filters-static-config';
import { VersionOverlayComponent } from 'projects/cvreporting/src/app/features/cvreporting/report-generator/overlays/version-overlay.component';
import { Dropdown } from 'primeng/dropdown';
const log = new Logger('GBF_SERVICE');
// Pages that ignore the minSelectableCustomDate limit
const MIN_SELECTABLE_CUSTOM_DATE_EXEMPT_PAGES = ['/insights/ct'];
import { Identifiers } from '@app/shared/services/app.config.type';
import { AppConfigurationService } from '@app/shared/services/app.configuration.service';
import { isEmpty } from 'lodash';
@Injectable({
  providedIn: 'root',
})
export class GlobalFilterService {
  public forceReRender: Subject<any> = new Subject();
  public gbfAppEvent: Subject<{ key: string; payload: any }> = new Subject();
  public gbfChangeState: Subject<any> = new Subject();
  public gbfTabChange: Subject<any> = new Subject();
  public gbfDateChange: Subject<any> = new Subject();
  public gbfChange: Subject<any> = new Subject();
  public gbfAllSet: Subject<any> = new Subject();
  public gbfResetState: Subject<any> = new Subject();
  public gbfApiCall: Subject<any> = new Subject();
  public gbfOnApplyFilter: Subject<any> = new Subject();
  public gbfSaveConfiguration: Subject<boolean> = new Subject();
  public $autoDatepickerDropdownSelect: BehaviorSubject<any> = new BehaviorSubject({});
  public gbfDefaultSelection: Subject<any> = new Subject();
  public gbfOnClose: Subject<any> = new Subject();
  // Fires with 'start|end' whenever the calendar is put back to its default range
  public gbfCalendarReset: Subject<{ dates: string; identifier: string }> = new Subject();
  show_suggestions = true;
  current_configs: Array<any> = [];
  current_tabs: Array<any> = [];
  dateFormat = 'MMM D, YYYY';
  dateTimeFormat = 'MMM D, YYYY hh:mm:ss A';
  currentMonth: any = moment();
  currentAllowedFilters = ['dealer', 'org', 'model', 'version', 'calendar'];
  program = '';
  tab = {
    label: '',
    value: '',
  };
  survey = {
    label: '',
    value: '',
  };
  survey_variation = {
    label: 'Quick Pulse',
    value: 'QP',
  };
  rg_survey_program = {
    label: '',
    value: '',
  };
  survey_variations = [
    {
      label: 'Quick Pulse',
      value: 'QP',
      IsChecked: true,
    },
  ];
  mulligan = {
    label: 'Unadjusted',
    value: 'Unadjusted',
  };
  mulligans = [
    {
      label: 'Unadjusted',
      value: 'Unadjusted',
      IsChecked: true,
    },
    {
      label: 'Adjusted',
      value: 'Adjusted',
      IsChecked: true,
    },
  ];
  dealer = { label: 'All', value: '' };
  date_group: Array<any> = [];
  disposition: Array<any> = [];
  version_rg = { label: '', value: '', version: '', Name: '', Key: '' };
  version = { label: '', value: '', version: '', versionName: '' };
  model = { Brand: '', Model: '', Year: '' };
  reviewStatus = [{ label: 'All', value: 'All' }];
  sources = [{ label: 'All', value: 'All' }];
  sentiment: any = { label: 'All Sentiment', value: 'All Sentiment', type: null };
  category = {
    level: 1,
    temp: true,
    parent: 'null',
    name: 'All Categories',
    label: 'All Categories',
    active: true,
    IsChecked: true,
  };
  surveytype: any;
  surveyQuestion: any = [];
  surveyResponse = [
    {
      level: -1,
      parent: 'null',
      name: 'All Survey Responses',
      label: 'All Survey Responses',
      active: true,
      IsChecked: true,
    },
  ];
  surveyScore: any;
  org_suggestions: any[] = [];
  multi_org: any[] = [];
  multi_model: any[] = [];
  org = {
    id: '',
    level: -1,
    parent: 'null',
    Identifier: '',
    NodeId: '',
    name: 'National',
    label: 'National',
    active: true,
    IsChecked: true,
  };
  // loginsummary_org = {
  //   id: '',
  //   level: -1,
  //   parent: 'null',
  //   Identifier: '',
  //   NodeId: '',
  //   name: 'National',
  //   label: 'National',
  //   active: true,
  //   IsChecked: true,
  // };
  suggestions: any[] = [];
  org_breadcrums: any[] = [];
  loginsummary_org_breadcrums: any[] = [];
  language = '';
  calendar = '';
  calendar1 = '';
  dateIdentifier = '';
  pageSize = 25;
  pageNo = 1;
  orgIdentifier: string;
  SortColumn = '';
  Sort = '';
  filterItem = '';
  field = '';
  authorizationData: any;
  currentUrl: string;
  isMultiOrg = false;
  isMultiModel = true;
  activatedUrl = '';
  currentOrgLevel = 1;
  isGreatorOrEqualMainNodeLevelSelected = false;
  isGreatorMainNodeLevelSelected = false;
  isLessMainNodeLevelSelected = false;
  calendardropdown: any = [];
  // Selected preset, for calendars that do not share the global one.
  dateIdentifiers: any = {};
  private neariestOrg: any = {};
  orgArray: Array<any> = [];
  public gbfOnCloseAll: Subject<any> = new Subject();
  public gbfOnFilterSave: Subject<any> = new Subject();

  constructor(
    public gbfConfig: GlobalFilterConfigService,
    public authService: AuthenticationService,
    public router: Router,
    private activatedRoute: ActivatedRoute,
    public translateService: TranslateService,
    private appConfig: AppConfigurationService,
    private location: Location
  ) {
    const isValid = localStorage.getItem('gbf_org_isvalid');
    if (isValid === 'false') {
      localStorage.removeItem('gbf_org_marked');
    }
    this.currentUrl = this.router.url;
    router.events.subscribe((event: any) => {
      // Guards are done, resolvers and components have not run, so nothing has built a payload yet.
      if (event instanceof ResolveStart) {
        const targetUrl = event.urlAfterRedirects || event.url;
        if (!this.isMinSelectableCustomDateExemptPage(targetUrl)) {
          this.resetCalendarIfBeforeMinSelectableDate();
        }
      }
      if (event instanceof NavigationEnd) {
        this.currentUrl = event.url;
      }
    });
    const h = JSON.parse(localStorage.getItem('authorizationData'));
    this.authorizationData = h;
    this.orgIdentifier = h?.OrgIdentifier;
    if (h && h.FilterBarConfig) {
      const DataAccessLevels = Array.isArray(this.authorizationData?.DataAccessLevels)
        ? this.authorizationData?.DataAccessLevels
        : [];
      this.gbfConfig.filterConfig = h.FilterBarConfig.FilterConfig;
      this.gbfConfig.filterConfig.config.unshift({
        type: 'list',
        dynamic: false,
        name: 'tab',
        title: ['label'],
        icons: { leftIcon: '' },
        localStorageKey: 'gbf_tab',
        placeholder: 'Select tab',
        rootClass: 'filter__item flex4',
        settings: { multi: true, listDoneButton: false, listStyleType: 'none', showTitle: false },
        values: [
          { label: 'Service', value: 'Service' },
          { label: 'Sales', value: 'Sales' },
        ],
      });

      var surveyPrograms = this.gbfConfig.filterConfig?.initialStates?.survey;
      var surveyValues: any;

      if (surveyPrograms != null && Array.isArray(surveyPrograms) && surveyPrograms.length > 0) {
        surveyValues = surveyPrograms;
      } else {
        surveyValues = this.gbfConfig.filterConfig.tabs;
      }

      this.gbfConfig.filterConfig.config.unshift({
        type: 'list',
        dynamic: false,
        name: 'survey',
        title: ['label'],
        icons: { leftIcon: '' },
        localStorageKey: 'gbf_survey',
        placeholder: this.translateService.instant('SelectProgram.label'),
        rootClass: 'filter__item flex4',
        settings: { multi: true, listDoneButton: false, listStyleType: 'none', showTitle: false },
        //values: this.gbfConfig.filterConfig.tabs,
        values: surveyValues,
      });

      this.gbfConfig.filterConfig.config = this.gbfConfig.filterConfig.config;
      const foundTab = JSON.parse(localStorage.getItem('gbf_tab'));
      if (foundTab && foundTab.value) {
        const tabsArr = foundTab.value.split(',');
        let surveyVersion = [];
        try {
          surveyVersion = JSON.parse(localStorage.getItem('surveyVersions') || '[]');
        } catch (error) {}
        if (tabsArr.length > 1) {
          const version = surveyVersion.find((x: any) => x.Event === tabsArr[0]);
          if (version && version.value) {
            this.version = {
              label: version.Event,
              value: version.value,
              version: version.value,
              versionName: version.Version,
            };
            localStorage.setItem('gbf_version', JSON.stringify(this.version));
          }
          this.tab = tabsArr[0];
        } else {
          this.tab = foundTab;
        }
      } else {
        if (this.gbfConfig.filterConfig.initialStates['tab']) {
          this.tab = this.gbfConfig.filterConfig.initialStates['tab'];
          if (this.tab) {
            localStorage.setItem('gbf_tab', JSON.stringify(this.tab));
          }
        }
      }
      this.gbfConfig.filterConfig.config.forEach((config: any) => {
        if (config.name === 'org' || config.name === 'multi_org' || config.name === 'loginsummary_org') {
          const DataAccessLevels = Array.isArray(this.authService?.authData?.DataAccessLevels)
            ? this.authService.authData.DataAccessLevels
            : [];
          if (DataAccessLevels.length > 1) {
            this.getNeariestLevel();
            const value = this.neariestOrg;
            if (value) {
              const UserOrg = {
                level: value.level,
                orginalLevel: value.orginalLevel,
                Identifier: value.identifier,
                NodeId: value.mProps.NodeId,
                MId: value.id,
                NodeName: value.NodeName,
                parent: value.parent,
                name: value.name,
                label: value.label,
                active: true,
                IsChecked: true,
              };
              config = this.restoreLocalStorageValues(config, UserOrg);
            } else {
              config = this.restoreLocalStorageValues(config);
            }
          } else {
            config = this.restoreLocalStorageValues(config);
          }
        } else {
          config = this.restoreLocalStorageValues(config);
        }
      });
    } else {
      this.router.navigate(['/unauthorized']);
    }
    // Refresh or direct hit on a page that does have the limit
    if (!this.isMinSelectableCustomDateExemptPage()) {
      this.resetCalendarIfBeforeMinSelectableDate();
    }
    this.buildOrgSuggestions();
    this.calendardropdown = [
      {
        label: 'R10',
        key: 'R10',
        value: () => [moment().subtract(10, 'days'), moment()],
      },
      {
        label: 'R30',
        key: 'R30',
        value: () => [moment().subtract(30, 'days'), moment()],
      },
      {
        label: 'MTD',
        key: 'MTD',
        value: (value: any = this.currentMonth) => [moment(value).startOf('month'), moment()],
      },
      {
        label: '3MTD',
        key: '3MTD',
        //value: (value: any = this.currentMonth) => [moment(value).startOf('month'), moment()],
        value: () => [moment().startOf('month').subtract(2, 'month'), moment()],
      },
      {
        label: 'QTD',
        key: 'QTD',
        value: (value: any = this.currentMonth) => [
          moment(value).quarter(moment(value).quarter()).startOf('quarter'),
          moment(value).get('month') === moment().get('month') ? moment() : moment(value).endOf('month'),
        ],
      },
      {
        label: 'YTD',
        key: 'YTD',
        value: (value: any = this.currentMonth) => [moment(value).startOf('year'), moment()],
      },
      {
        label: 'M36',
        key: 'M36',
        value: () => [moment().subtract(-36, 'month'), moment()],
      },
      {
        // tslint:disable-next-line:max-line-length
        label: 'previous_month.label',
        key: 'PREVIOUS MONTH',
        value: () => [moment().subtract(1, 'month'), moment()],
      },
      {
        // tslint:disable-next-line:max-line-length
        label: 'previous_quarter.label',
        key: 'PREVIOUS QUARTER',
        value: () => [moment().subtract(1, 'month'), moment()],
      },
      {
        // tslint:disable-next-line:max-line-length
        label: 'previous_year.label',
        key: 'PREVIOUS YEAR',
        value: () => [moment().subtract(1, 'month'), moment()],
      },
      // tslint:disable-next-line:max-line-length
      {
        label: 'program_to_date.label',
        key: 'PROGRAM TO DATE',
        value: () => [moment().add(1, 'month').startOf('month'), moment().add(2, 'month')],
      },
      {
        label: this.translateService.instant('custom_range.label'),
        key: 'CUSTOM RANGE',
        value: (): any => [],
      },
    ];
  }

  restoreLocalStorageValues(config: any, orgDefaultValue = {}) {
    const DataAccessLevels = Array.isArray(this.authService?.authData?.DataAccessLevels)
      ? this.authService.authData.DataAccessLevels
      : [];
    if (config.localStorageKey) {
      try {
        const found = JSON.parse(localStorage.getItem(config.localStorageKey));
        if (found && config.type === 'tree') {
          if (found.selected) {
            (this as any)[config.name] = found.selected;
            (this as any)[config.name + '_full'] = {
              selected: found.selected,
              selectedTreeItems: found.selectedTreeItems,
            };
          }
          if (found.breadcrums) {
            (this as any)[config.name + '_breadcrums'] = found.breadcrums;
          }
        } else {
          if (found) {
            (this as any)[config.name] = found;
          } else {
            if (this.gbfConfig.filterConfig.initialStates[config.name]) {
              this.gbfConfig.filterConfig.initialStates[config.name].temp = true;
              if (config.name === 'org' || config.name === 'multi_org' || config.name === 'loginsummary_org') {
                const maxdataAccessLevel = Math.max.apply(
                  Math,
                  DataAccessLevels.map((o: any) => o.Level)
                );
                const dataAccessLevel = DataAccessLevels.find((x: any) => x.Level === maxdataAccessLevel);
                if (!dataAccessLevel) {
                  this.router.navigate(['/unauthorized']);
                  return;
                }
                let UserOrg = {};
                if (isEmpty(orgDefaultValue)) {
                  const initialSelectedFilter =
                    this.authService?.authData?.FilterBarConfig?.FilterConfig?.initialStates?.default_selection;
                  const isNationUser = this.authService?.authData?.DataAccessLevels[0];
                  if (initialSelectedFilter && isNationUser.Level == 1) {
                    UserOrg = {
                      level: initialSelectedFilter.level,
                      orginalLevel: initialSelectedFilter.level,
                      Identifier: initialSelectedFilter.identifier,
                      NodeId: initialSelectedFilter.node_id,
                      MId: initialSelectedFilter._id,
                      NodeName: initialSelectedFilter.name,
                      parent: initialSelectedFilter.parent_ids,
                      name: initialSelectedFilter.name,
                      label: initialSelectedFilter.label,
                      active: true,
                      IsChecked: true,
                    };
                  } else {
                    UserOrg = {
                      level: dataAccessLevel.Level,
                      orginalLevel: dataAccessLevel.Level,
                      Identifier: dataAccessLevel.Identifier,
                      NodeId: dataAccessLevel.NodeId,
                      MId: dataAccessLevel.Id,
                      NodeName: dataAccessLevel.Name,
                      parent: dataAccessLevel.ParentId,
                      name: dataAccessLevel.Name,
                      label: dataAccessLevel.Label,
                      active: true,
                      IsChecked: true,
                    };
                  }
                } else {
                  UserOrg = orgDefaultValue;
                }

                (this as any)[config.name] = config.name == 'multi_org' ? [UserOrg] : UserOrg;
                (this as any)[config.name + '_breadcrums'] = [UserOrg];
                (this as any)[config.name + '_full'] = {
                  selected: UserOrg,
                  selectedTreeItems: UserOrg,
                };
                localStorage.setItem(
                  config.localStorageKey,
                  JSON.stringify({
                    breadcrums: [UserOrg],
                    selected: config.name == 'multi_org' ? [UserOrg] : UserOrg,
                    selectedTreeItems: config.name == 'multi_org' ? [UserOrg] : UserOrg,
                  })
                );
              } else {
                const activeQPDG: any = this.appConfig.getByIdentifier('active-qp-dg');
                let defaultVersionSelection = false;
                if (activeQPDG['Fields'] && activeQPDG['Fields'] && activeQPDG['Fields']['defaultVersionSelection']) {
                  defaultVersionSelection = activeQPDG['Fields']['defaultVersionSelection'];
                }
                if (defaultVersionSelection && config.name === 'version') {
                  this.gbfConfig.filterConfig.initialStates[config.name] = JSON.parse(
                    localStorage.getItem('gbf_version_qp')
                  );
                }
                (this as any)[config.name] = this.gbfConfig.filterConfig.initialStates[config.name];
                localStorage.setItem(config.localStorageKey, JSON.stringify((this as any)[config.name]));
                (this as any)[config.name + '_breadcrums'] = [this.gbfConfig.filterConfig.initialStates[config.name]];
                (this as any)[config.name + '_full'] = {
                  selected: this.gbfConfig.filterConfig.initialStates[config.name],
                  selectedTreeItems: this.gbfConfig.filterConfig.initialStates[config.name],
                };
              }
            } else {
              (this as any)[config.name + '_full'] = {
                selected: [],
                selectedTreeItems: [],
              };
            }
          }
        }
      } catch (error) {
        log.debug('parsing error');
      }
    }
    return config;
  }

  // Which calendar a call is about. No argument, or 'calendar', behaves exactly as before.
  resolveCalendarConfig(config?: any): any {
    const name = typeof config === 'string' ? config : config?.name;
    if (!name || name === 'calendar') {
      let calendarSettings: any = {
        name: 'calendar',
        type: 'calendar',
        format: this.dateTimeFormat,
        localStorageKey: 'gbf_calendar',
      };
      const found = this.gbfConfig.filterConfig.config.find((x: any) => x.name === 'calendar');
      if (found) {
        calendarSettings = found;
      }
      return calendarSettings;
    }
    const found = this.gbfConfig.filterConfig.config.find((x: any) => x.name === name);
    if (found) {
      return found;
    }
    // Unknown name: use what we were given rather than answer with the global calendar's dates.
    return typeof config === 'object' ? config : { name, type: 'calendar', localStorageKey: 'gbf_' + name };
  }

  // Calendars the whole app reads. They keep dateIdentifier and gbf_date_identifier.
  // The calendar component asks this too, so the two cannot drift apart.
  isSharedCalendarName(name?: string): boolean {
    return !name || name === 'calendar' || name === 'calendar1';
  }

  // localStorage key holding the selected preset for a calendar.
  getDateIdentifierStorageKey(config?: any): string {
    return this.dateIdentifierKeyFor(this.resolveCalendarConfig(config));
  }

  private dateIdentifierKeyFor(resolved: any): string {
    if (!resolved || this.isSharedCalendarName(resolved.name)) {
      return 'gbf_date_identifier';
    }
    return (resolved.localStorageKey || 'gbf_' + resolved.name) + '_identifier';
  }

  setDateIdentifier(data: any, config?: any) {
    const resolved = this.resolveCalendarConfig(config);
    if (this.isSharedCalendarName(resolved.name)) {
      this.dateIdentifier = data;
    } else {
      this.dateIdentifiers[resolved.name] = data;
    }
    localStorage.setItem(this.dateIdentifierKeyFor(resolved), data);
  }
  getDispositions(config: any, initialState: any) {
    return {
      Disposition: (this.disposition || []).map((disp: any) => ({
        Label: disp.label,
        Code: disp.value,
        Type: disp.type,
        Name: disp.Name,
      })),
    };
  }
  getUpdatedVersion(config: any, initialState: any) {
    return {
      version_rg: {
        label: 'V21',
        value: 'V21',
        version: 'V21',
        versionName: 'V21',
      },
    };
  }
  getDateGroups(config: any, initialState: any) {
    return {
      DateGroup: (this.date_group || []).map((dg: any) => ({ Label: dg.label, Value: dg.value, Type: dg.Type })),
    };
  }
  getDateIdentifier(config?: any) {
    const resolved = this.resolveCalendarConfig(config);
    if (this.isSharedCalendarName(resolved.name)) {
      if (this.dateIdentifier) {
        return this.dateIdentifier;
      }
      if (localStorage.getItem('gbf_date_identifier')) {
        const dateIdentifier = localStorage.getItem('gbf_date_identifier');
        if (dateIdentifier) {
          this.dateIdentifier = dateIdentifier;
          return dateIdentifier;
        }
      }
      return null;
    }
    if (this.dateIdentifiers[resolved.name]) {
      return this.dateIdentifiers[resolved.name];
    }
    const stored = localStorage.getItem(this.dateIdentifierKeyFor(resolved));
    if (stored) {
      this.dateIdentifiers[resolved.name] = stored;
      return stored;
    }
    return null;
  }

  setSurveyVersion(version: any) {
    localStorage.setItem('gbf_version', JSON.stringify(version));
    this.version = version;
  }
  setTab(en: string, fireEvent = true) {
    let act_tab = this.current_tabs.find((x) => x.value === en) ?? localStorage.getItem('gbf_tab');
    if (this.current_tabs.find((x) => x.value === en)) localStorage.setItem('gbf_tab', JSON.stringify(act_tab));
    if (fireEvent) {
      this.gbfTabChange.next(act_tab.value);
    }
  }
  getSurveyVersion() {
    if (this.version) {
      return this.version.version || this.version.value;
    } else {
      const survey = JSON.parse(localStorage.getItem('gbf_version'));
      if (survey) {
        return survey.version || survey.value;
      }
    }
  }
  getCalender1Range() {
    let calendarSettings: any = {
      name: 'calendar1',
      type: 'calendar',
      format: this.dateTimeFormat,
      localStorageKey: 'gbf_calendar1',
    };
    const found = this.gbfConfig.filterConfig.config.find((x: any) => x.name === 'calendar1');
    if (found) {
      calendarSettings = found;
    }
    calendarSettings.dateTimeFormat = this.dateTimeFormat;
    let date: any = this.calendar1;
    if (!date) {
      date = localStorage.getItem(calendarSettings.localStorageKey);
    }
    if (date) {
      date = date.split('|');
      if (date.length > 1) {
        const start = moment(date[0]).format(calendarSettings.dateTimeFormat);
        const end = moment(date[1]).endOf('day').format(calendarSettings.dateTimeFormat);
        return [start, end];
      }
    } else {
      const start = this.getStartDateRange1inNumber(
        calendarSettings,
        calendarSettings.range,
        calendarSettings.dateTimeFormat
      );
      const end = this.getEndDateRange1inNumber(calendarSettings.range, calendarSettings.dateTimeFormat);
      return [start, end];
    }
  }
  // Checks the current page, or pass a url to check the one we are heading to
  isMinSelectableCustomDateExemptPage(url?: string): boolean {
    const path = (url ?? this.location.path() ?? '').split('?')[0].split('#')[0];
    return MIN_SELECTABLE_CUSTOM_DATE_EXEMPT_PAGES.some((page) => path === page || path.startsWith(page + '/'));
  }

  // The calendar range is shared across the app, so a date picked on an exempt page has to go back
  // to the configured range before another page uses it. Returns the new range, or null if untouched.
  resetCalendarIfBeforeMinSelectableDate(): string | null {
    const calendarSettings = this.gbfConfig?.filterConfig?.config?.find((x: any) => x.name === 'calendar');
    // No limit configured means no fallback either, keep whatever the user picked
    if (!calendarSettings?.settings?.minSelectableCustomDate || !calendarSettings.range) {
      return null;
    }
    // The limit only ever applied to the custom range picker, presets like MTD can go further back
    if ((this.getDateIdentifier() || '').toUpperCase() !== 'CUSTOM RANGE') {
      return null;
    }
    const minDate = moment(calendarSettings.settings.minSelectableCustomDate, 'MM-DD-YYYY');
    const selected = this.calendar || localStorage.getItem(calendarSettings.localStorageKey);
    if (!minDate.isValid() || typeof selected !== 'string') {
      return null;
    }
    const selectedStart = moment(new Date(selected.split('|')[0]));
    if (!selectedStart.isValid() || !selectedStart.isBefore(minDate, 'day')) {
      return null;
    }
    const format = this.dateTimeFormat;
    const restored = [
      this.getStartDateRangeinNumber(calendarSettings, calendarSettings.range, format),
      this.getEndDateRangeinNumber(calendarSettings.range, format),
    ]
      .map((date: any) => (moment.isMoment(date) ? date.format(format) : date))
      .join('|');
    this.calendar = restored;
    if (calendarSettings.localStorageKey) {
      localStorage.setItem(calendarSettings.localStorageKey, restored);
    }
    localStorage.setItem('filter_date', restored);
    this.setDateIdentifier(calendarSettings.range);
    this.gbfCalendarReset.next({ dates: restored, identifier: calendarSettings.range });
    return restored;
  }

  // No argument = app-wide calendar. Pass a config, or its name, for that calendar's own range.
  getCalenderRange(config?: any): any {
    const calendarSettings: any = this.resolveCalendarConfig(config);
    calendarSettings.dateTimeFormat = this.dateTimeFormat;
    let date: any = (this as any)[calendarSettings.name];
    if (!date) {
      date = localStorage.getItem(calendarSettings.localStorageKey);
    }
    if (date) {
      date = date.split('|');
      if (date.length > 1) {
        const start = moment(date[0]).format(calendarSettings.dateTimeFormat);
        const end = moment(date[1]).endOf('day').format(calendarSettings.dateTimeFormat);
        return [start, end];
      }
    } else {
      const start = this.getStartDateRangeinNumber(
        calendarSettings,
        calendarSettings.range,
        calendarSettings.dateTimeFormat
      );
      const end = this.getEndDateRangeinNumber(calendarSettings.range, calendarSettings.dateTimeFormat);
      return [start, end];
    }
  }
  public setSuggestions(name: string, items: any) {
    this.org_suggestions = items;
  }

  public buildOrgSuggestions(xlevel?: number) {
    const level = xlevel || this.getSelectedOrgLevel();
    const lastLevel = this.authService?.authData?.LastNodeLevel;
    const values: any[] = [];
    this.org_suggestions = this.org_suggestions.map((x) => {
      x.IsChecked = x.level < level ? false : x.IsChecked;
      return x;
    });
    for (let i = level; i <= lastLevel; i++) {
      values.push({
        level: i,
        label: this.translateService.instant(`Level${i}`),
        value: `level${i}`,
        IsChecked: this.org_suggestions.find((x) => x.value === `level${i}`)?.IsChecked || false,
        IsPartialChecked: false,
        disabled: false,
      });
    }
    this.suggestions = values;
  }

  getCalenderDropDown(dropdown: any = null) {
    let calendardropdown: any = [
      {
        label: 'R10',
        key: 'R10',
        value: () => [moment().subtract(10, 'days'), moment()],
      },
      {
        label: 'R30',
        key: 'R30',
        value: () => [moment().subtract(30, 'days'), moment()],
      },
      {
        label: 'R90',
        key: 'R90',
        value: () => [moment().subtract(90, 'days'), moment()],
      },
      {
        label: 'MTD',
        key: 'MTD',
        value: (value: any = this.currentMonth) => [moment(value).startOf('month'), moment()],
      },
      {
        label: '3MTD',
        key: '3MTD',
        //value: (value: any = this.currentMonth) => [moment(value).startOf('month'), moment()],
        value: () => [moment().startOf('month').subtract(2, 'month'), moment()],
      },
      {
        label: '6MTD',
        key: '6MTD',
        value: () => [moment().startOf('month').subtract(5, 'month'), moment()],
      },
      {
        label: 'QTD',
        key: 'QTD',
        value: (value: any = this.currentMonth) => [
          moment(value).quarter(moment(value).quarter()).startOf('quarter'),
          moment(value).get('month') === moment().get('month') ? moment() : moment(value).endOf('month'),
        ],
      },
      {
        label: 'YTD',
        key: 'YTD',
        value: (value: any = this.currentMonth) => [moment(value).startOf('year'), moment()],
      },
      {
        label: 'FYTD',
        key: 'FYTD',
        value: (value: any = this.currentMonth) => [
          moment(value).startOf('year').add(3, 'month') < moment()
            ? moment(value).startOf('year').add(3, 'month')
            : moment(value).startOf('year').subtract(1, 'year').add(3, 'month'),
          moment(),
        ],
      },
      {
        label: 'M36',
        key: 'M36',
        value: () => [moment().subtract(-36, 'month'), moment()],
      },
      {
        // tslint:disable-next-line:max-line-length
        label: this.translateService.instant('previous_month.label'),
        key: 'PREVIOUS MONTH',
        value: () => [moment().subtract(1, 'month'), moment()],
      },
      {
        // tslint:disable-next-line:max-line-length
        label: this.translateService.instant('previous_quarter.label'),
        key: 'PREVIOUS QUARTER',
        value: () => [moment().subtract(1, 'month'), moment()],
      },
      {
        // tslint:disable-next-line:max-line-length
        label: this.translateService.instant('previous_year.label'),
        key: 'PREVIOUS YEAR',
        value: () => [moment().subtract(1, 'month'), moment()],
      },
      // tslint:disable-next-line:max-line-length
      {
        label: this.translateService.instant('program_to_date.label'),
        key: 'PROGRAM TO DATE',
        value: () => [moment().add(1, 'month').startOf('month'), moment().add(2, 'month')],
      },
      {
        label: this.translateService.instant('custom_range.label'),
        key: 'CUSTOM RANGE',
        value: (): any => [],
      },
    ];
    // Presets may sit at the top level or under settings; otherwise fall back to the app-wide one.
    const inline = dropdown?.dateDropDown || dropdown?.settings?.dateDropDown;
    const list =
      inline || this.resolveCalendarConfig(dropdown)?.dateDropDown || this.resolveCalendarConfig()?.dateDropDown;
    if (list) {
      list.map((obj: any) => {
        // Match on key: labels are localised, so a client's wording ('CM' for MTD) never matches
        // the catalogue. Label match kept as a fallback so existing configs resolve as before.
        const find =
          this.calendardropdown.find((x: any) => x.key === obj.key) ||
          this.calendardropdown.find((x: any) => x.Key == obj.Key && x.label == obj.label);
        if (find) {
          obj.value = find.value;
          // Labels are translated in place, so keep the original key or the first translation
          // sticks for the session. instant() returns the key when there is no entry, so a
          // client's own wording ('CM') survives untouched.
          if (!obj.translateKey) {
            obj.translateKey = obj.label || find.label;
          }
          obj.label = this.translateService.instant(obj.translateKey);
        }
      });
      return list;
    } else return null;
  }
  getCalender1DropDown() {
    const found = this.gbfConfig.filterConfig.config.find((x: any) => x.name === 'calendar1');
    if (found && found.dateDropDown) {
      let dropdown = found.dateDropDown;
      dropdown.map((obj: any) => {
        var find = this.calendardropdown.find((x: any) => x.Key == obj.Key && x.label == obj.label);
        if (find) {
          obj.key === find.key;
          obj.label = this.translateService.instant(find.label);
          obj.value = find.value;
        }
      });
      return dropdown;
    } else return null;
  }
  getStartDateRangeinNumber(calendarSettings: any, identifier: string, format: string) {
    switch (identifier) {
      case 'YTD': {
        return moment(this.currentMonth).startOf('year').format(format);
      }
      case 'R10': {
        return moment().subtract(10, 'days').format(format);
      }
      case 'R30': {
        return moment().subtract(30, 'days').format(format);
      }
      case 'MTD': {
        return moment(this.currentMonth).startOf('month').format(format);
      }
      case '3MTD': {
        return moment().startOf('month').subtract(2, 'month').format(format);
      }
      case '6MTD': {
        return moment().startOf('month').subtract(5, 'month').format(format);
      }
      case '12MTD': {
        return moment().startOf('month').subtract(11, 'month').format(format);
      }
      case 'QTD': {
        return moment(this.currentMonth).quarter(moment(this.currentMonth).quarter()).startOf('quarter');
      }
      case 'PREVIOUS MONTH': {
        return moment().subtract(1, 'month').format(format);
      }
      case 'PREVIOUS QUARTER': {
        return moment().subtract(1, 'month').format(format);
      }
      case 'PREVIOUS YEAR': {
        return moment().subtract(1, 'year').format(format);
      }
      case 'PROGRAM TO DATE': {
        return moment(new Date(calendarSettings.launchDate)).format(format);
      }
      case 'CUSTOM RANGE': {
        return moment(this.currentMonth).startOf('year').format(format);
      }
      case 'M36': {
        return moment(new Date()).add(-36, 'month').format(format);
      }
      default: {
        return moment(new Date()).startOf('month').format(format);
      }
    }
  }
  getEndDateRangeinNumber(identifier: string, format: string) {
    switch (identifier) {
      case 'YTD': {
        return moment().format(format);
      }
      case 'R10': {
        return moment().format(format);
      }
      case 'R30': {
        return moment().format(format);
      }
      case 'MTD': {
        return moment().format(format);
      }
      case '3MTD': {
        return moment().format(format);
      }
      case '6MTD': {
        return moment().format(format);
      }
      case '12MTD': {
        return moment().format(format);
      }
      case 'QTD': {
        return moment().format(format);
      }
      case 'PREVIOUS MONTH': {
        return moment().format(format);
      }
      case 'PREVIOUS QUARTER': {
        return moment().format(format);
      }
      case 'PREVIOUS YEAR': {
        return moment().format(format);
      }
      case 'PROGRAM TO DATE': {
        return moment().format(format);
      }
      case 'CUSTOM RANGE': {
        return moment().format(format);
      }
      default: {
        return moment().format(format);
      }
    }
  }
  getStartDateRange1inNumber(calendarSettings: any, identifier: string, format: string) {
    switch (identifier) {
      case 'YTD': {
        return moment(this.currentMonth).startOf('year').format(format);
      }

      case 'MTD': {
        return moment(this.currentMonth).startOf('month').format(format);
      }

      default: {
        return moment(new Date()).startOf('month').format(format);
      }
    }
  }
  getEndDateRange1inNumber(identifier: string, format: string) {
    switch (identifier) {
      case 'YTD': {
        return moment().format(format);
      }

      case 'MTD': {
        return moment().format(format);
      }

      default: {
        return moment().format(format);
      }
    }
  }
  getActiveOrgHierarchy() {
    const localOrg: any = localStorage.getItem('gbf_org');
    const rValue = {
      OrgName: this.authorizationData?.OrganizationName,
      OrgLevel: this.authorizationData?.Level,
      OrgParent: this.authorizationData?.ParentOrganization,
    };
    let org: any = this.org;
    if (!org && localOrg) {
      org = JSON.parse(localOrg).selected;
    }
    if (org) {
      rValue.OrgName = org.name;
      rValue.OrgLevel = org.level > 0 ? org.level : 1;
      rValue.OrgParent = org.parent;
    }
    return rValue;
  }
  getSurveyQuestionResponses(name: string, initialState: any) {
    let surveyResponses: any = [];
    if (
      (this as any)['surveyResponse_full'].selected &&
      Array.isArray((this as any)['surveyResponse_full'].selectedTreeItems)
    ) {
      surveyResponses = [
        ...(this as any)['surveyResponse_full'].selected,
        ...(this as any)['surveyResponse_full'].selectedTreeItems,
      ];
    } else {
      const localStorageSurveyResponses: any = JSON.parse(localStorage.getItem('gbf_survey_response'));
      if (localStorageSurveyResponses) {
        surveyResponses = [...localStorageSurveyResponses.selected, ...localStorageSurveyResponses.selectedTreeItems];
      }
    }
    const parents = surveyResponses.filter((x: any) => x && x.parent === 'null');
    const cache: any = [];
    const reponses: any = [];
    if (parents && parents.length > 0) {
      parents.forEach((val: any) => {
        if (val.mProps && cache.indexOf(val.id) === -1) {
          cache.push(val.id);
          const vResponse: any = {};
          const options = surveyResponses.filter((x: any) => x && x.parent === val.name);
          vResponse.Id = val.id;
          vResponse.QuestionId = val.mProps.QuestionId;
          vResponse.Title = val.mProps.Title;
          vResponse.Type = val.mProps.Type;
          vResponse.Options = options.map((o: any) => {
            return {
              Id: o.Id ? o.Id : o.id,
              Title: o.label,
            };
          });
          if (vResponse.Options.length > 0) {
            reponses.push(vResponse);
          }
        }
      });
    }
    return { SurveyResponses: reponses };
  }
  getlanguageCode(name: string, initialState: any) {
    let languages: any = [];
    if (this.language) {
      languages = this.language;
    } else {
      const localStorageLanguages: any = JSON.parse(localStorage.getItem('gbf_language'));
      if (localStorageLanguages) {
        languages = localStorageLanguages;
      }
    }
    let languageCodefiled: any = [];
    if (languages) {
      languages.map((x: any) => {
        if (x.IsChecked && x.Name !== 'All') {
          languageCodefiled.push(x.LanguageCode);
        }
      });
    } else {
      languageCodefiled = [];
    }
    if (languageCodefiled && languageCodefiled.length > 0) {
      return { LanguageCode: languageCodefiled };
    } else {
      return { LanguageCode: [] };
    }
  }
  getSurveyQuestion(name: string, initialState: any) {
    let surveyQuestion: any = [];
    if (this.surveyQuestion) {
      surveyQuestion = this.surveyQuestion;
    } else {
      const localStorageSurveyQuestion: any = JSON.parse(localStorage.getItem('gbf_survey_question'));
      if (localStorageSurveyQuestion) {
        surveyQuestion = localStorageSurveyQuestion;
      }
    }
    let isselectAll = [];
    if (surveyQuestion) {
      isselectAll = surveyQuestion.filter((x: any) => x.IsChecked === true);
    }
    if (isselectAll.length > 0) {
      if (surveyQuestion && surveyQuestion.length > 0) {
        surveyQuestion = surveyQuestion.filter((obj: any) => {
          delete obj.IsSelected;
          obj.Options = obj.Options.filter((o: any) => {
            const flag = o.IsChecked;
            delete o.IsChecked;
            delete o.IsSelected;
            return flag ? true : false;
          });
          return obj?.Id?.toLowerCase() !== 'all' && obj?.IsChecked === true;
        });
      }
    } else {
      if (surveyQuestion && surveyQuestion.length > 0) {
        surveyQuestion = surveyQuestion.filter((obj: any) => {
          delete obj.IsSelected;
          obj.Options = obj.Options.filter((o: any) => {
            const flag = o.IsChecked;
            delete o.IsChecked;
            delete o.IsSelected;
            return flag ? true : false;
          });
          return obj.Id.toLowerCase() !== 'all';
        });
      }
    }
    return { SurveyQuestions: surveyQuestion };
  }
  getCategory(name: string, initialState: any) {
    let category: any = {
      id: 1,
      level: 0,
      name: 'All Category',
    };
    if (this.category) {
      category = this.category;
    } else {
      const localStorageCategory: any = JSON.parse(localStorage.getItem('gbf_category'));
      if (localStorageCategory) {
        category = localStorageCategory;
      }
    }
    return {
      CategoryId: category.id,
      CategoryLevel: category.temp ? category.level : category.level + 1,
      CategoryName: category.name,
    };
  }
  getSurveyScore(name: string, initialState: any) {
    let surveyScore: any = {
      Id: '',
      Type: 'global_filter_label.Survey Score',
      Score: this.getFilterScoreConfigurationData(),
      Types: [],
    };
    if (!this.surveyScore) {
      this.surveyScore = surveyScore;
    } else {
      const localStorageSurveyScore: any = JSON.parse(localStorage.getItem('gbf_survey_score'));
      if (localStorageSurveyScore) {
        surveyScore = localStorageSurveyScore;
      }
    }
    return {
      ScoreRangeType: surveyScore.Type,
      ScoreRangeMin: surveyScore.Score[0],
      ScoreRangeMax: surveyScore.Score[1],
    };
  }

  getFilterScoreConfigurationData() {
    const opts = this.appConfig.getByIdentifier(Identifiers.FilterBarScoreRange);
    if (opts) {
      if (opts.ClientConfig === null) {
        opts.ClientConfig = opts;
      }
      if (opts.ClientConfig) {
        return opts.ClientConfig.Fields;
      } else {
        return [0, 100];
      }
    } else {
      return [0, 100];
    }
  }
  getModel(name: string, initialState: any) {
    let model: any = {
      ActiveModal: '',
      ActiveModalClass: '',
      ActiveModalYear: '',
    };
    if (this.model) {
      model = this.model;
    } else {
      const local: any = JSON.parse(localStorage.getItem('gbf_mby'));
      if (local && local.selected) {
        model = local.selected;
      }
    }
    return {
      ActiveModal: model.Model === 'All Models' ? '' : model?.Model || model?.mProps?.Model || '',
      ActiveModalClass: model.Brand === 'All Brands' ? '' : model?.Brand || model?.mProps?.Brand || '',
      ActiveModalYear: model.Year === 'All Years' ? '' : model?.Year || model?.mProps?.Year || '',
    };
  }
  getMultiOrg(name: string, initialState: any) {
    let orgs: any = [];
    if (this.multi_org && this.multi_org.length > 0) {
      orgs = this.multi_org;
    } else {
      const orgLocal: any = JSON.parse(localStorage.getItem('gbf_multi_org'));
      if (orgLocal && orgLocal.selected) {
        orgs = orgLocal.selected;
      }
    }
    if (!Array.isArray(orgs)) {
      orgs = [orgs];
    }
    const maxOrgLevel = Math.max.apply(
      Math,
      orgs.map((o: any) => {
        return o.level;
      })
    );
    const mOrgs: any[] = [];
    orgs = orgs.filter((org: any) => org.level === maxOrgLevel);
    if (orgs) {
      orgs.forEach((org: any) => {
        mOrgs.push({
          OrgLabel: org.label || org.Label || org.mProps?.label || org.mProps?.Label || '', // Org Label
          OrgNodeName: org.NodeName || org.mProps?.NodeName, // NodeId
          OrgName: org.NodeId || org.mProps?.NodeId, // NodeId
          OrgParent: org.parent || org.mProps?.parent, // Org Parent
          OrgLevel: org.level || org.mProps?.level, // Org Parent
          OrgIdentifier: org.Identifier || org.mProps?.Identifier, // Identifier
        });
      });
    }
    if (mOrgs && mOrgs.length > 0) {
      const OrgLabel = mOrgs
        .map((o) => o.OrgLabel)
        .filter(Boolean)
        .join(', ');
      return { Orgs: mOrgs, OrgLevel: maxOrgLevel, ...mOrgs[0], OrgLabel };
    } else {
      (this as any)[name] = initialState;
      return {
        Orgs: initialState,
        OrgLevel: 1,
        OrgLabel: initialState.OrgLabel || '',
        OrgParent: initialState.OrgParent || 'null',
        OrgName: initialState.NodeId,
        OrgNodeName: initialState.name,
        OrgIdentifier: initialState.Identifier,
      };
    }
  }
  getMultiOrgHeatMap(name: string, initialState: any) {
    let orgs: any = [];
    if (this.multi_org && this.multi_org.length > 0) {
      orgs = this.multi_org;
    } else {
      const orgLocal: any = JSON.parse(localStorage.getItem('gbf_multi_org'));
      if (orgLocal && orgLocal.selected) {
        orgs = orgLocal.selected;
      }
    }
    if (!Array.isArray(orgs)) {
      orgs = [orgs];
    }

    const mOrgs: any[] = [];
    // orgs = orgs.filter((org: any) => org.level === maxOrgLevel);
    if (orgs) {
      orgs.forEach((org: any) => {
        mOrgs.push({
          OrgNodeName: org.NodeName || org.mProps?.NodeName, // NodeId
          OrgName: org.NodeId || org.mProps?.NodeId, // NodeId
          OrgParent: org.parent || org.mProps?.parent, // Org Parent
          OrgLevel: org.level || org.mProps?.level, // Org Parent
          OrgIdentifier: org.Identifier || org.mProps?.Identifier, // Identifier
        });
      });
    }
    if (mOrgs && mOrgs.length > 0) {
      return { Orgs: mOrgs, OrgLevel: orgs, ...mOrgs[0] };
    } else {
      (this as any)[name] = initialState;
      return {
        Orgs: initialState,
        OrgLevel: 1,
        OrgParent: initialState.OrgParent || 'null',
        OrgName: initialState.NodeId,
        OrgNodeName: initialState.name,
        OrgIdentifier: initialState.Identifier,
      };
    }
  }
  getMultiModel(name: any, initialState: any) {
    const modelConfig = this.gbfConfig.filterConfig.config.find((x: any) => x.name == name.filter);
    let selectedModels: any = [];
    if (this.multi_model && this.multi_model.length > 0) {
      selectedModels = this.multi_model;
    } else {
      const modelLocal: any = JSON.parse(localStorage.getItem('gbf_multi_mby'));
      if (modelLocal && modelLocal.selected) {
        selectedModels = modelLocal.selected;
      }
    }
    let years: any[] = [];
    let models: any[] = [];
    let brands: any[] = [];
    if (selectedModels) {
      selectedModels.forEach((model: any) => {
        if (model.mProps) {
          if (model.mProps.Year) {
            years.push(model.mProps.Year);
          }
          if (model.mProps.Model) {
            const _model = model.mProps.Model ? model.mProps.Model.trim() : model.mProps.Model;
            models.push(_model);
          }
          if (model.mProps.Brand) {
            brands.push(model.mProps.Brand);
          }
        }
      });
    }
    const yearGroups = years.filter((x: any) => x.indexOf('YearGroup') > -1);
    if (yearGroups && yearGroups.length > 0) {
      yearGroups.forEach((yg: any) => {
        years = years.filter((y) => y != yg);
        const yearGroupYears = selectedModels.find((sm: any) => sm.name == yg)?.mProps?.yearGroupYears;
        years.push(...yearGroupYears);
      });
    }
    let result = {
      ActiveModels: [...new Set(models)].filter((x) => x != undefined && x != null),
      ActiveBrands: [...new Set(brands)].filter((x) => x != undefined && x != null),
      ActiveYears: [...new Set(years)].filter((x) => x != undefined && x != null),
    };
    return result;
  }

  getOrg(name: string, initialState: any) {
    let org: any = {
      NodeId: '',
      parent: '',
      level: '',
      Identifier: '',
    };
    let orgs_path_temp: Array<any> = [];
    let orgs_path: Array<any> = [];
    if (this?.org?.NodeId) {
      const orgLocal: any = JSON.parse(localStorage.getItem('gbf_org'));
      org = this.org;
      orgs_path_temp = orgLocal.breadcrums;
    } else {
      const orgLocal: any = JSON.parse(localStorage.getItem('gbf_org'));
      if (orgLocal && orgLocal.selected) {
        org = orgLocal.selected;
        orgs_path_temp = orgLocal.breadcrums;
      } else if (orgLocal && orgLocal.NodeId) {
        org = orgLocal;
      }
    }
    orgs_path_temp.forEach((orgPath) => {
      const Org = {
        OrgLabel: orgPath?.label || org?.Label || '',
        OrgNodeName: orgPath?.NodeName, // NodeId
        Id: org.id || orgPath?.mProps?.Name, // NodeId
        OrgName: orgPath.NodeId || orgPath?.mProps?.NodeId, // NodeId
        OrgParent: orgPath.parent || orgPath?.mProps?.parent, // Org Parent
        OrgLevel: orgPath.orginalLevel || orgPath.level, // Org Parent
        OrgIdentifier: orgPath.Identifier || orgPath?.mProps?.Identifier, // Identifier
      };
      orgs_path.push(Org);
    });

    const Org = {
      OrgLabel: org?.label || org?.Label || '',
      OrgNodeName: org?.NodeName, // NodeId
      Id: org.id || org?.mProps?.Name, // NodeId
      OrgName: org.NodeId || org?.mProps?.NodeId, // NodeId
      OrgParent: org.parent || org?.mProps?.parent, // Org Parent
      OrgLevel: org.orginalLevel || org.level, // Org Parent
      OrgIdentifier: org.Identifier || org?.mProps?.Identifier, // Identifier
    };

    if (Array.isArray(orgs_path) && orgs_path.length > 0) {
      const at0 = orgs_path[0];
      if (at0.OrgLevel > 1) {
        orgs_path = this.authService.authData.OrgPath.map((org: any) => {
          return {
            OrgLabel: org?.Label,
            OrgNodeName: org?.Name, // NodeId
            Id: org?.Id,
            OrgName: org.NodeId,
            OrgParent: org.ParentId, // Org Parent
            OrgLevel: org.Level, // Org Parent
            OrgIdentifier: org.Identifier, // Identifier
          };
        });
      }
    } else {
      orgs_path = [];
    }

    // const Org = {
    //   OrgNodeName: org.NodeName, // NodeId
    //   Id: org.id || org.mProps.Name, // NodeId
    //   OrgName: org.NodeId || org.mProps.NodeId, // NodeId
    //   OrgParent: org.parent || org.mProps.parent, // Org Parent
    //   OrgLevel: org.level, // Org Parent
    //   OrgIdentifier: org.Identifier || org.mProps.Identifier, // Identifier
    // };
    return { Orgs: [Org], ...Org, OrgsPath: orgs_path };
  }

  getLoginSummaryOrg(name: string, initialState: any) {
    let org: any = {
      NodeId: '',
      parent: '',
      level: '',
      Identifier: '',
    };
    let orgs_path_temp: Array<any> = [];
    let orgs_path: Array<any> = [];
    // if (this?.loginsummary_org?.NodeId) {
    //   const orgLocal: any = JSON.parse(localStorage.getItem('gbf_loginsummary_org'));
    //   org = this.loginsummary_org;
    //   orgs_path_temp = orgLocal.breadcrums;
    // } else {
    //   const orgLocal: any = JSON.parse(localStorage.getItem('gbf_loginsummary_org'));
    //   if (orgLocal && orgLocal.selected) {
    //     org = orgLocal.selected;
    //     orgs_path_temp = orgLocal.breadcrums;
    //   } else if (orgLocal && orgLocal.NodeId) {
    //     org = orgLocal;
    //   }
    // }
    const orgLocal: any = JSON.parse(localStorage.getItem('gbf_loginsummary_org'));
    if (orgLocal && orgLocal.selected) {
      org = orgLocal.selected;
      orgs_path_temp = orgLocal.breadcrums;
    } else if (orgLocal && orgLocal.NodeId) {
      org = orgLocal;
    }
    orgs_path_temp.forEach((orgPath) => {
      const Org = {
        OrgLabel: orgPath?.label || org?.Label || '',
        OrgNodeName: orgPath?.NodeName, // NodeId
        Id: org.id || orgPath?.mProps?.Name, // NodeId
        OrgName: orgPath.NodeId || orgPath?.mProps?.NodeId, // NodeId
        OrgParent: orgPath.parent || orgPath?.mProps?.parent, // Org Parent
        OrgLevel: orgPath.orginalLevel || orgPath.level, // Org Parent
        OrgIdentifier: orgPath.Identifier || orgPath?.mProps?.Identifier, // Identifier
      };
      orgs_path.push(Org);
    });
    const Org = {
      OrgLabel: org?.label || org?.Label || '',
      OrgNodeName: org?.NodeName, // NodeId
      Id: org.id || org?.mProps?.Name, // NodeId
      OrgName: org.NodeId || org?.mProps?.NodeId, // NodeId
      OrgParent: org.parent || org?.mProps?.parent, // Org Parent
      OrgLevel: org.orginalLevel || org.level, // Org Parent
      OrgIdentifier: org.Identifier || org?.mProps?.Identifier, // Identifier
    };

    if (Array.isArray(orgs_path) && orgs_path.length > 0) {
      const at0 = orgs_path[0];
      if (at0.OrgLevel > 1) {
        orgs_path = this.authService.authData.OrgPath.map((org: any) => {
          return {
            OrgLabel: org?.Label,
            OrgNodeName: org?.Name, // NodeId
            Id: org?.Id,
            OrgName: org.NodeId,
            OrgParent: org.ParentId, // Org Parent
            OrgLevel: org.Level, // Org Parent
            OrgIdentifier: org.Identifier, // Identifier
          };
        });
      }
    } else {
      orgs_path = [];
    }

    // const Org = {
    //   OrgNodeName: org.NodeName, // NodeId
    //   Id: org.id || org.mProps.Name, // NodeId
    //   OrgName: org.NodeId || org.mProps.NodeId, // NodeId
    //   OrgParent: org.parent || org.mProps.parent, // Org Parent
    //   OrgLevel: org.level, // Org Parent
    //   OrgIdentifier: org.Identifier || org.mProps.Identifier, // Identifier
    // };
    return { Orgs: [Org], ...Org, OrgsPath: orgs_path };
  }

  getDates(name: string, initialState: any) {
    const dateRange = this.getCalenderRange();
    return {
      DateIdentifier: this.getDateIdentifier(),
      StartDate: dateRange[0],
      EndDate: dateRange[1],
    };
  }
  getDatesdailyreport(name: string, initialState: any) {
    const dateRange = this.getCalender1Range();
    return {
      DateIdentifier: this.getDateIdentifier(),
      StartDate: dateRange[0],
      EndDate: dateRange[1],
    };
  }

  getSelectedOrgLevel() {
    if (this.isMultiOrg) {
      this.currentOrgLevel = this.getMultiOrg('multi_org', {}).OrgLevel;
    } else {
      this.currentOrgLevel = this.getOrg('org', {}).OrgLevel;
    }
    return this.currentOrgLevel;
  }

  setSelectedOrgLevel() {
    if (this.isMultiOrg) {
      this.currentOrgLevel = this.getMultiOrg('multi_org', {}).OrgLevel;
    } else {
      this.currentOrgLevel = this.getOrg('org', {}).OrgLevel;
    }
    this.isGreatorOrEqualMainNodeLevelSelected = this.currentOrgLevel >= this.authService.getUser().MainNodeLevel;
    this.isGreatorMainNodeLevelSelected = this.currentOrgLevel > this.authService.getUser().MainNodeLevel;
    this.isLessMainNodeLevelSelected = this.currentOrgLevel < this.authService.getUser().MainNodeLevel;
  }

  getDealer(name: string, initialState: any) {
    return {
      DealerType: this.dealer.value,
    };
  }
  getVersion(name: string, initialState: any) {
    return {
      SurveyVersion: this.version.value,
    };
  }
  getVersionQP(name: string, initialState: any) {
    return {
      SurveyVersion: (this as any).version_qp.value,
    };
  }
  setVersionQP(data: any) {
    (this as any).version_qp = data;
    localStorage.setItem('gbf_version_qp', JSON.stringify(data));
  }
  getSources(name: string, initialState: any) {
    const checked = this.sources.filter((x: any) => x.IsChecked === true);
    if (checked) {
      return {
        SourceType: this.sources.map((x: any) => {
          return {
            Id: x.value,
            IsChecked: x.IsChecked,
            Title: x.label,
          };
        }),
      };
    } else {
      return {
        SourceType: initialState,
      };
    }
  }

  setSentiment(data: any) {
    var sentiment = JSON.parse(localStorage.getItem('gbf_sentiments'));
    if (sentiment) this.sentiment = { label: sentiment.label, value: sentiment.label, type: sentiment.value };
  }

  getSentiments(name: string, initialState: any) {
    return {
      SentimentType: this.sentiment.type,
    };
  }
  getDynamicFilterObject() {
    if (this.currentUrl.includes('?')) {
      this.currentUrl = this.currentUrl.split('?')[0];
    }
    let localUrl = this.currentUrl;
    if (this.activatedUrl) {
      localUrl = this.activatedUrl;
      if (this.activatedUrl == '/insights/reports/statistics') {
        this.currentUrl = this.activatedUrl;
      }
      this.activatedUrl = '';
    }
    //let localUrl = this.currentUrl.replace(window.location.search, '');
    const filterConfig = this.gbfConfig.filterConfig;
    let tabs = this.gbfConfig.filterConfig.pageConfig['default']['tabs'];
    let configs = this.gbfConfig.filterConfig.pageConfig['default']['filter'];
    if (filterConfig.pageConfig[filterConfig.pageUrlPrefix + localUrl]) {
      configs = filterConfig.pageConfig[filterConfig.pageUrlPrefix + localUrl]['filter'];
      tabs = filterConfig.pageConfig[filterConfig.pageUrlPrefix + localUrl]['tabs'];
      const _staticPageConfig = (StaticPageConfig as any)[filterConfig.pageUrlPrefix + localUrl];
      if (_staticPageConfig && _staticPageConfig['filter']) {
        configs = [...configs, ..._staticPageConfig['filter']];
      }
      if (_staticPageConfig && _staticPageConfig['tabs']) {
        tabs = [...tabs, ..._staticPageConfig['tabs']];
      }
    }
    let filterObject: any = {};
    configs.forEach((filter: any) => {
      let f = this.gbfConfig.filterConfig.returnFilter[filter] || (StaticReturnFilter as any)[filter];
      let initialState = this.gbfConfig.filterConfig.initialStates[filter] || StaticIntialState[filter];
      if (f) {
        f.filter = filter;
        if (f.signature === 'method') {
          if ((this as any)[f.name]) {
            filterObject = { ...filterObject, ...(this as any)[f.name](f, initialState) };
          }
        } else if (f.signature === 'property') {
          if ((this as any)[f.name] && (this as any)[f.name][f.valueProp]) {
            filterObject[f.filterKey] = (this as any)[f.name][f.valueProp];
          } else if ((this as any)[f.name]) {
            filterObject[f.filterKey] = (this as any)[f.name];
          }
        }
      }
    });

    if (!this.dateIdentifier) {
      const found = this.gbfConfig.filterConfig.config.find((x: any) => x.name === 'calendar');
      if (found) {
        this.dateIdentifier = found.range;
      }
    }
    return { tabs: tabs, filters: filterObject };
  }
  getFilterObject() {
    // const currentOrgLevel = this.getSelectedOrgLevel();
    // const dataAccessLevel = this.authService.authData.DataAccessLevels.find(Boolean);

    // if (currentOrgLevel < dataAccessLevel.Level) {
    //   throw new Error("Org level not allowed");
    // }

    const filter = this.getDynamicFilterObject();
    const filters = {
      PageSize: this.pageSize,
      PageNo: this.pageNo,
      Fields: this.field,
      Filters: this.filterItem,
      Status: '',
      SortColumn: this.SortColumn,
      Sort: this.Sort,
      ...filter.filters,
    };
    // if (!filter.tabs) {
    if (this?.tab && this?.tab?.value) {
      filters.Event = this.tab.value;
    } else if (Array.isArray(this.tab) && this.tab.length > 0 && this.tab[0].value) {
      filters.Event = this.tab[0].value;
    }
    // }
    if (!this.version || !this.version.value) {
      const version = JSON.parse(localStorage.getItem('surveyVersions'))?.find(
        (x: any) => x.Event === this?.tab?.value || true
      );
      if (version && version.value) {
        this.version = {
          label: version.label,
          value: version.value,
          version: version.value,
          versionName: version.Version,
        };
        localStorage.setItem('gbf_version', JSON.stringify(this.version));
        filters.SurveyVersion = version.value;
      }
    }
    return filters;
  }

  public applyYearGroupPredicate(predicate: string, year: string): boolean {
    //"YearGroup_GraterThan-CurrentYear-Minus-7","YearGroup_LessThan-CurrentYear-Minus-6"
    const currentYear = moment().get('year');
    predicate = predicate.replace('CurrentYear', currentYear.toString());
    var predicateParts = predicate.split('_')[1].split('-');
    if (predicateParts[0] == 'GraterThan') {
      if (predicateParts[2] == 'Minus') {
        return parseInt(year) > parseInt(predicateParts[1]) - parseInt(predicateParts[3]);
      }
      if (predicateParts[2] == 'Plus') {
        return parseInt(year) > parseInt(predicateParts[1]) + parseInt(predicateParts[3]);
      }
    }
    if (predicateParts[0] == 'LessThan') {
      if (predicateParts[2] == 'Minus') {
        return parseInt(year) < parseInt(predicateParts[1]) - parseInt(predicateParts[3]);
      }
      if (predicateParts[2] == 'Plus') {
        return parseInt(year) < parseInt(predicateParts[1]) + parseInt(predicateParts[3]);
      }
    }
    return false;
  }

  public getTreeAsArray(array: any[]) {
    const maxLevel = Math.max(...array.map((item) => item.level));
    const children = array.filter((x) => x.Level === maxLevel);
    const maxTrees: any[] = [];

    const mapProperties = (element: any) => {
      return {
        id: element.id,
        parent: element.parent,
        name: element.name,
        value: element.value,
        level: element.level,
      };
    };

    const findNestedItems = (parent: string, index: number) => {
      const found = array.find((x) => x.id == parent);
      if (found) {
        maxTrees[index].push(mapProperties(found));
        findNestedItems(found.parent, index);
      }
    };

    children.forEach((element, index) => {
      maxTrees.push([mapProperties(element)]);
      findNestedItems(element.parent, index);
    });

    return maxTrees.map((x) => x.reverse());
  }

  private getNeariestLevel() {
    const records = this.authService.orgListData;
    let selectedLevel = this.authService?.authData?.MainNodeLevel;
    for (let level = 1; level <= selectedLevel; level++) {
      const found = records.filter((x: any) => x.level === level);
      if (found.length === 1) {
        const items = records.filter((x: any) => x.level === level + 1) || [];
        if (items.length == 0) {
          this.neariestOrg = found[0];
          break;
        } else if (items.length > 1) {
          this.neariestOrg = found[0];
          break;
        } else {
        }
      } else {
        this.neariestOrg = found[0];
        break;
      }
    }
  }
}
